import Button from "@components/common/Button";
import styledParser from "@libs/parser/styled-parser";
import { useRouter } from "next/router";

interface ISectionWrapper {
  title: string;
  body?: string;
  link?: string;
  children: JSX.Element | JSX.Element[];
  hasDots?: boolean;
  hasHalfIndentation?: boolean;
  className?: string;
}

const SectionWrapper = ({
  title,
  body,
  link,
  children,
  hasDots,
  hasHalfIndentation,
  className = "desktop:min-h-[446px]",
}: ISectionWrapper): JSX.Element => {
  const router = useRouter();
  return (
    <div className={`relative mb-[2.375rem] desktop:m-0 desktop:mb-[3rem]`}>
      <div className="mx-5 flex items-start justify-between desktop:mx-0 ">
        <div className="mx-auto w-full desktop:max-w-[1376px]">
          {title && (
            <h2 className="mt-4 mb-2 text-h2 font-semibold desktop:mt-6 desktop:mb-3">
              {title}
            </h2>
          )}
          {body && (
            <div className="pb-2 text-p text-darkgray desktop:pb-5">
              {styledParser(body)}
            </div>
          )}
        </div>
        {/* <div className="hidden text-p font-semibold text-orange underline decoration-orange-20 decoration-dashed underline-offset-4 hover:decoration-orange desktop:block"> */}
        {/* Hidden for initial Release - NAM-1687 */}
        {/* <Link href={STATIC_LANDING_PAGES_URLS.BEST}>Explore All</Link> */}
        {/* </div> */}
      </div>
      <div
        className={`${
          hasHalfIndentation ? "ml-[0.6rem] w-full" : "ml-[0.6rem]"
        } ${className}`}
      >
        {children}
      </div>
      {link && (
        <div
          className={`mx-auto mt-6 flex w-full max-w-[400px] justify-center px-5 desktop:px-0 ${
            hasDots ? "desktop:mt-[3.25rem]" : "desktop:mt-9"
          }`}
        >
          <Button
            variant="tertiary"
            onClick={(): void => {
              router.push(link).catch(() => {});
            }}
          >
            Explore All
          </Button>
        </div>
      )}
    </div>
  );
};

export default SectionWrapper;
